import { setApplicationStore as _setApplicationStore, reducer } from 'legacy/lut/store/index'

export const setApplicationStore = _setApplicationStore
export { reducer }
